import { useContext, type FC } from 'react';
import { Button, CircularProgress } from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import { AppContext } from '../../App';
import { useDownloadCsv } from './hooks/useDownloadCsv';
import { matTimestamp } from '../../utils/matTimestamp';
import { btnSubtlePrimarySx } from '../common/filterStyles';

const TemplateDownloadButton: FC = () => {
  const { isStaff } = useContext(AppContext);
  const { download, loading } = useDownloadCsv((mat) => mat.templateCsv.bind(mat));

  if (!isStaff) return null;

  const handleDownload = () => {
    download('all', {}, (i) => `mat-template-${i}-${matTimestamp()}.csv`);
  };

  return (
    <Button
      onClick={handleDownload}
      data-cy="btn-template-mat"
      disabled={loading}
      variant="outlined"
      sx={btnSubtlePrimarySx}
      startIcon={
        loading ? <CircularProgress size={14} /> : <DownloadIcon sx={{ fontSize: 16 }} />
      }
    >
      {loading ? 'Preparing...' : 'Template'}
    </Button>
  );
};

export default TemplateDownloadButton;
